import { FindColorsToOfflineOutput } from '../../../../../../../../../services/modules/colors/colors.types';
import { OfflineDatabaseColor } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseColor.types';
import { offlineColorsRepository } from '../../../../../../../repositories/offlineColors.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';

export class ColorsQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority'>) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    return generateQueryKeysAndFnToPaginatedEndpoint<FindColorsToOfflineOutput>({
      url: '/colors/offline/v1',
      priority: this.params.priority,
      fnToSaveData: async (data) => {
        await offlineColorsRepository.saveAll(data.map(this.toOfflineData));
      },
    });
  }

  private toOfflineData(data: FindColorsToOfflineOutput): OfflineDatabaseColor {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
    };
  }
}
